import { render, staticRenderFns } from "./Wines.vue?vue&type=template&id=33b47152&scoped=true"
import script from "./Wines.vue?vue&type=script&lang=js"
export * from "./Wines.vue?vue&type=script&lang=js"
import style0 from "./Wines.vue?vue&type=style&index=0&id=33b47152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b47152",
  null
  
)

export default component.exports